// import external dependencies
import 'jquery';
// Import everything from autoload
import '../autoload/_bootstrap.js';

import './whatsapp-submission';
import './unit-type-modal';
import './countdown-timer'
export default {
  init() {

  },
  finalize() {
    // JavaScript to be fired on the page template, after the init JS
  },
};


// WEBPACK FOOTER //
// ./scripts/custom-elementor-widget/page-widget.js